import { stringify } from 'qs';

export const apiV1 = '/api/v1';
export const apiV2 = '/api/v2';

export const stringifyQuery = (params) => {
  if (params) {
    return `?${stringify(params)}`;
  }
  return '';
};
// 调研工场域名（落地页）
export const Landingpage = 'http://sw.treeyee.com';
// 调研工场登录页
export const Loginpage = 'http://sw.treeyee.com/login';
// 调研工厂测试环境域名
// export const testDomain = 'http://test.qyconsult.treeyee.com:3000';
export const testDomain = 'http://test.front.base.survey.work';
// 就业服务企业id 测试环境
export const JOBIDTEST = 252;
//  就业服务企业id 生产环境
export const JOBIDPRO = 199;
